import { useLocalizedNavigate } from '../../../hooks/useLocalizedNavigate';
import { format, isBefore, parseISO } from 'date-fns';
import { UnpopulatedEvent } from '../../../utils/types';
import { COLOURS, eventTypeMap } from '../../../utils/consts';
import { useTranslation } from '../../../hooks/translations/TranslationProvider';
import { Icon, TextField, Title } from '..';
import { useAppSelector } from '../../../store/hooks';
import { renderEventDate } from '../../../utils/helpers';

import './eventRowSmall.css';

interface EventRowSmallProps {
    isListView?: boolean;
    eventRecord: UnpopulatedEvent;
    isWinner?: boolean;
    isMvp?: boolean;
    showVoteEndDate?: boolean;
    actionRequired?: boolean;
    isUserPage?: boolean;
}

const EventRowSmall: React.FC<EventRowSmallProps> = ({
    eventRecord,
    isListView,
    isWinner,
    isMvp,
    showVoteEndDate,
    actionRequired = false,
    isUserPage = false,
}) => {
    const navigate = useLocalizedNavigate();
    const { t } = useTranslation();
    const auth = useAppSelector(state => state.auth);
    const language = auth.authData?.language;

    const eventClickHandler = (eventId: string) => {
        navigate(`/events/${eventId}`);
    };

    const voteEndDate = eventRecord.voteEndDate
        ? format(new Date(eventRecord.voteEndDate), 'dd/MM/yyyy, HH:mm')
        : null;

    const isPastEvent = isBefore(parseISO(eventRecord.date), new Date());

    return (
        <div
            className={`event-row-small clickable ${
                isPastEvent &&
                !actionRequired &&
                !showVoteEndDate &&
                !isUserPage
                    ? 'disabled'
                    : ''
            }`}
            onClick={() => eventClickHandler(eventRecord.id)}
        >
            <div className="event-row-small-record">
                <div className="event-row-small-record-details">
                    <Icon name={`bx-${eventRecord.type.toLowerCase()}`} />
                    <div>
                        <Title
                            text={`${eventTypeMap[eventRecord.type]} - ${
                                eventRecord.name
                            }`}
                            size="s"
                        />
                        <div
                            style={{
                                display: 'flex',
                                gap: '10px',
                                alignItems: 'center',
                            }}
                        >
                            <TextField size="s" color="subtitle">
                                {renderEventDate(eventRecord.date, language, {
                                    todayLabel: t('date.today'),
                                    atLabel: t('date.at'),
                                })}
                            </TextField>
                            <TextField>•</TextField>
                            <TextField size="s" color="subtitle">
                                {eventRecord.address}, {eventRecord.city}
                            </TextField>
                        </div>
                    </div>
                </div>

                <div className="event-row-small-icons">
                    {isListView ? (
                        <>
                            <Icon name="bx-user-check" />
                            <TextField color="green">
                                {`${eventRecord.joinedUsers}/${eventRecord.maxUsers}`}
                            </TextField>
                        </>
                    ) : showVoteEndDate ? (
                        <TextField color="green">{`${t(
                            'common.voteEnds'
                        )} ${voteEndDate}`}</TextField>
                    ) : actionRequired ? (
                        <>
                            <Icon name="bx-user-check" />
                            <TextField color="green">
                                {`${eventRecord.joinedUsers}/${eventRecord.maxUsers}`}
                            </TextField>
                            <Icon name="bx-error" color={COLOURS.RED} />
                            <TextField color="red">
                                {t('common.actionRequired')}
                            </TextField>
                        </>
                    ) : (
                        <>
                            {isWinner && (
                                <Icon name="bx-trophy" color="#333332" />
                            )}
                            {isMvp && <Icon name="bx-star" color="#333332" />}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default EventRowSmall;
